import { mapScalarExpression } from "./expressions/scalar";
import { mapFunctionCall } from "./primitives";
/**
 * Create a context object with utility functions.
 */
export class CstToAstContext {
    text;
    constructor(text) {
        this.text = text;
    }
    slice = (node) => {
        return this.text.slice(node.from, node.to);
    };
    getChild = (node, typeName) => {
        let child = node.firstChild;
        while (child) {
            if (child.type.name === typeName) {
                return child;
            }
            child = child.nextSibling;
        }
        return null;
    };
    getChildren = (node, typeName) => {
        const children = [];
        let child = node.firstChild;
        while (child) {
            if (child.type.name === typeName) {
                children.push(child);
            }
            child = child.nextSibling;
        }
        return children;
    };
    parseStringLiteral = (raw) => {
        // Handle verbatim strings @"..." or @'...'
        if (raw.startsWith('@"') && raw.endsWith('"')) {
            return raw.slice(2, -1);
        }
        if (raw.startsWith("@'") && raw.endsWith("'")) {
            return raw.slice(2, -1);
        }
        // Handle obfuscated strings h"..." or h@"..."
        if (raw.startsWith('h@"') && raw.endsWith('"')) {
            return raw.slice(3, -1);
        }
        if (raw.startsWith('h"') && raw.endsWith('"')) {
            return raw.slice(2, -1);
        }
        // Handle regular strings "..." or '...'
        if ((raw.startsWith('"') && raw.endsWith('"')) ||
            (raw.startsWith("'") && raw.endsWith("'"))) {
            // Simple unescape (handle \", \', \\, \n, \t, \r)
            return raw
                .slice(1, -1)
                .replace(/\\"/g, '"')
                .replace(/'/g, "'")
                .replace(/\\\\/g, "\\")
                .replace(/\\n/g, "\n")
                .replace(/\\t/g, "\t")
                .replace(/\\r/g, "\r");
        }
        return raw;
    };
    mapScalarExpression = (node) => {
        return mapScalarExpression(node, this);
    };
    mapFunctionCall = (node) => {
        return mapFunctionCall(node, this);
    };
    errorNode = (node, msg) => {
        return {
            type: "ErrorNode",
            error: msg,
            from: node.from,
            to: node.to,
        };
    };
}
